import { useState } from 'react'
// import { useMount } from 'ahooks'
import { useCorpInfoStore, useCartStore } from '@/stores'
import { utils, apis, constant } from '@/utils'
import type { OrderPickType, OrderLogistics } from '@/pages/Order/types'

const { to } = utils
const { orderApi } = apis
const {
  order: { PickType },
} = constant

const BASE_OPTIONS = {
  pageSize: 10, pageNum: 1
}

function useGetLogistics(options: any = {}): any {
  options = { ...BASE_OPTIONS, ...options }
  const { corpInfo } = useCorpInfoStore()
  const { cart } = useCartStore()
  const { corpId } = corpInfo
  const { cartId } = cart
  const [extend, setExtend] = useState({})

  // 获取第一个有效物流
  async function getFirstValidLogistics(params: any = {}) {
    const res = await getLogisticsList({...options, ...params})
    if (!res?.data) return
    const handleDatas: OrderPickType[] = res.data || []
    const firstValidData = handleDatas[0]
    return firstValidData
  }

  // 获取物流列表
  async function getLogisticsList(params: { pageNum: number; pageSize: number, crossBorder: number }): Promise<any> {
    const { pageNum, pageSize, crossBorder } = params
    const [err, res] = await to(
      orderApi.queryLogisticsList({
        cartId,
        corpId,
        pageNum,
        pageSize,
        crossBorder,
      })
    )

    if (err || !res) {
      throw err
    }

    const resData: OrderLogistics[] = res.data || []
    const handleDatas: OrderPickType[] = resData.map((data) => handleLogisticsData(data))
    setExtend(res.extend || {})

    return {
      ...res,
      data: handleDatas,
    }
  }

  // 把后端物流数据处理成前端需要的数据
  function handleLogisticsData(data: OrderLogistics) {
    const {
      countryName = '',
      provinceName = '',
      cityName = '',
      districtName = '',
      address = '',
      shippingFee,
      codServiceFee,
      logisticsType,
    } = data

    let shipAddress = ''
    let shippingTotal = 0
    // 自提
    if (logisticsType === PickType.SELF_PICK) {
      shippingTotal = shippingFee
      shipAddress =
        countryName + provinceName + cityName + districtName + address
    } else {
      shippingTotal = shippingFee + codServiceFee
    }
    return {
      ...data,
      shipAddress,
      shippingTotal,
      codFee: codServiceFee,
      pickType: logisticsType,
    }
  }

  return {
    getLogisticsList,
    getFirstValidLogistics,
    extend,
  }
}

export default useGetLogistics